import * as React from "react";

import { JSX } from "react/jsx-runtime";

const LibraryIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={27}
    height={26}
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="library">
      <path
        id="Vector"
        d="M2.66675 7.58333C2.66675 6.06653 2.66675 5.30812 2.96193 4.72877C3.2216 4.21917 3.63592 3.80485 4.14552 3.54519C4.72486 3.25 5.48327 3.25 7.00008 3.25C8.51689 3.25 9.2753 3.25 9.85464 3.54519C10.3642 3.80485 10.7786 4.21917 11.0382 4.72877C11.3334 5.30812 11.3334 6.06653 11.3334 7.58333V18.4167C11.3334 19.9334 11.3334 20.6919 11.0382 21.2713C10.7786 21.7809 10.3642 22.1951 9.85464 22.4548C9.2753 22.75 8.51689 22.75 7.00008 22.75C5.48327 22.75 4.72486 22.75 4.14552 22.4548C3.63592 22.1951 3.2216 21.7809 2.96193 21.2713C2.66675 20.6919 2.66675 19.9334 2.66675 18.4167V7.58333Z"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M7 18.4167H7.00898"
        stroke="black"
        strokeWidth={2.16667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M2.66675 7.58331H11.3334"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M12.9027 8.95746C12.5182 7.51658 12.3261 6.79614 12.4584 6.17065C12.5749 5.62046 12.8618 5.12142 13.2781 4.74505C13.7513 4.31717 14.4688 4.12413 15.9037 3.73804C17.3385 3.35196 18.056 3.15892 18.6788 3.29187C19.2268 3.40881 19.7237 3.69694 20.0985 4.11494C20.5246 4.59015 20.7169 5.3106 21.1014 6.75147L23.8474 17.0426C24.2319 18.4834 24.4241 19.2038 24.2917 19.8293C24.1752 20.3796 23.8884 20.8785 23.472 21.255C22.9988 21.6828 22.2814 21.8759 20.8465 22.262C19.4116 22.6481 18.6941 22.8411 18.0713 22.7082C17.5234 22.5912 17.0264 22.303 16.6516 21.8851C16.2255 21.4098 16.0332 20.6894 15.6488 19.2486L12.9027 8.95746Z"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M19.7629 18.0868L19.7716 18.0845"
        stroke="black"
        strokeWidth={2.16667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_6"
        d="M13.5 8.66687L20.5418 6.5"
        stroke="black"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default LibraryIcon;
